export interface CalendarConfig {
  hourHeight: number;
  headerHeight: number;
  timeColumnWidth: number;
  minHour: number;
  maxHour: number;
}

export const defaultConfig: CalendarConfig = {
  hourHeight: 80,
  headerHeight: 60,
  timeColumnWidth: 60,
  minHour: 0,
  maxHour: 24,
};
